var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.252,
    height: 36.307,
    viewBox: "0 0 40.252 36.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17225",
    "data-name": "Group 17225",
    transform: "translate(-190.637 -136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8619",
    "data-name": "Rectangle 8619",
    width: 36.226,
    height: 36.226,
    rx: 18.113,
    transform: "translate(190.637 136.081)",
    fill: "#2f67d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(194.111 139.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.148,14l-1.208-2a4.486,4.486,0,0,1-.483-1.787V7.149a7.149,7.149,0,0,0-14.3,0V10.2a4.379,4.379,0,0,1-.483,1.775L.458,14A2.822,2.822,0,0,0,2.04,18.258a22.584,22.584,0,0,0,7.269,1.183,22.906,22.906,0,0,0,7.269-1.171A2.912,2.912,0,0,0,18.148,14Z",
    transform: "translate(5.205 3.502)",
    fill: "#fff",
    opacity: 0.997
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M5.374,1.594a7.365,7.365,0,0,0-2.693-.507A7.105,7.105,0,0,0,0,1.594,3.023,3.023,0,0,1,2.681,0,3.041,3.041,0,0,1,5.374,1.594Z",
    transform: "translate(11.834 2.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.823.012a3.64,3.64,0,0,1-3.417,2.4A3.581,3.581,0,0,1,.845,1.34,3.334,3.334,0,0,1,0,0C.157.024.314.036.483.06c.278.036.568.072.857.1.688.06,1.389.1,2.089.1S4.806.217,5.482.157c.254-.024.507-.036.749-.072Z",
    transform: "translate(11.085 24.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H28.981V28.981H0Z",
    transform: "translate(0 0)",
    fill: "none",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    transform: "translate(215.891 136)",
    fill: "#de1e1e",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.499,
    cy: 7.499,
    r: 7.499,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.499,
    cy: 7.499,
    r: 6.499,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell2);
export default __webpack_public_path__ + "static/media/bell2.7c9e3b33275a6401081a8c7f91b418b7.svg";
export { ForwardRef as ReactComponent };